import { __ } from '@wordpress/i18n';
import { ViewsIcon } from "../../../../Utils/icons";
// perf(SMASH-1836): import the submodule, not the a11y barrel — the barrel
// drags the admin-only Radix stack (accordion/tabs) into the public feed bundle.
import { VisuallyHidden } from '../../../../a11y/VisuallyHidden';

// a11y(SMASH-1377 F6): the eye icon's meaning was visual-only — SR users
// heard a bare number (WCAG 1.1.1). Append SR-only text naming the metric.
const Views = ({ post, fillColor }) => {
    return (
        <span className='sb-post-item-meta-views'>
            <ViewsIcon fillColor={fillColor} />
            {post?.view_count}
            <VisuallyHidden>{__('views', 'sb-customizer')}</VisuallyHidden>
        </span>
    );
}

export default Views;
